// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__e62L7","innerContainer":"Footer_innerContainer__IU407","title":"Footer_title__JqnTa","link":"Footer_link__-uGR9"};